module.exports = __webpack_public_path__ + "img/Augenknoten.e5f3b4cb.jpg";